import type { InputPuzzle } from "./puzzle.types";

export const TRAINEE_PUZZLES: InputPuzzle[] = [
  {
    p: "003094750400073000978002003037010008200340067800726905309000000502060301760030004",
    s: "123894756456173829978652413637915248295348167814726935349581672582467391761239584",
    d: -7414,
  },
  {
    p: "120000000070060000500043070000070386005806001460002957000001200050020693000530000",
    s: "123957864974168532586243179219475386735896421468312957397681245851724693642539718",
    d: -7098,
  },
  {
    p: "020009000859000610760410092000000009600397050300000007006900100230700900070654230",
    s: "124569783859273614763418592517846329642397851398125467486932175235781946971654238",
    d: -7318,
  },
  {
    p: "000985600097300800050670900305096000716508020240000000000851090978003006531700200",
    s: "124985637697312845853674912385296471716548329249137568462851793978423156531769284",
    d: -7090,
  },
  {
    p: "100040008000250036460798501800000905006024307000080162200000079308502010607000050",
    s: "125643798789251436463798521832167945516924387974385162251436879398572614647819253",
    d: -7541,
  },
  {
    p: "026070908049800000570029006000053000000602000905080160400560090701008603052001480",
    s: "126375948349816725578429316264153879817692534935784162483567291791248653652931487",
    d: -7226,
  },
  {
    p: "020034507740625103830000600261050008070000960500000301000040009680510000900000010",
    s: "126834597749625183835791642261953478473182965598467321317246859682519734954378216",
    d: -7318,
  },
  {
    p: "109000607057060003000704950080040010904008032000507004090030470041800300560079008",
    s: "129385647457961283836724951685243719974618532312597864298136475741852396563479128",
    d: -7226,
  },
  {
    p: "000036000007908000008107950243005198800000007750890300080670005670001039900350076",
    s: "129536784537948621468127953243765198896213547751894362382679415675481239914352876",
    d: -7090,
  },
  {
    p: "100000075065217300000000000537000004206004018040952000000091203000408000013005006",
    s: "129863475465217389378549162537186924296374518841952637784691253652438791913725846",
    d: -7376,
  },
  {
    p: "000400900240010007070800034800206019900000300603974025080060001092000053060700090",
    s: "138457962249613587576892134854236719927581346613974825485369271792148653361725498",
    d: -7318,
  },
  {
    p: "109700005004006100000002040000005000006210053910037020060000934407023516090460802",
    s: "139784265724356189658192347372845691846219753915637428261578934487923516593461872",
    d: -7226,
  },
  {
    p: "100305098090000000080179602624000000800607420370040800068004930030008060005006204",
    s: "142365798796482315583179642624853179851697423379241856268514937437928561915736284",
    d: -7226,
  },
  {
    p: "040098003950300800008201060000000348403000100005000090701560084004810005500430612",
    s: "142698573956374821378251469697125348423986157815743296731562984264819735589437612",
    d: -7226,
  },
  {
    p: "100500007090830004800200100400010072000048351001302006204900715315007690000000023",
    s: "143569287792831564856274139438615972629748351571392846264983715315427698987156423",
    d: -7541,
  },
  {
    p: "003000096000300105950610000470006052086925401502004039800200017200500000005490060",
    s: "143852796627349185958617324479136852386925471512784639894263517261578943735491268",
    d: -7541,
  },
  {
    p: "105089060390700415706500000600090040003120906910050200250400007060000003009000004",
    s: "145389762398762415726541389672893541583124976914657238251438697467915823839276154",
    d: -7318,
  },
  {
    p: "040000000000000100938104607060489003401035006790261004804690070300500400050800021",
    s: "145976832276358149938124657562489713481735296793261584814692375329517468657843921",
    d: -7541,
  },
  {
    p: "000327005837005000020168040651809400000500030903014050090081000408702001010000804",
    s: "146327985837945216529168743651839472284576139973214658392481567468752391715693824",
    d: -7541,
  },
  {
    p: "040008000930060000008009053503170408000200300002940060017090230350627901000001540",
    s: "146358792935762814278419653593176428461285379782943165817594236354627981629831547",
    d: -7226,
  },
  {
    p: "000000090300501004500400816690000720705906048010000500800000000901630402004810907",
    s: "146782395389561274527493816698154723735926148412378569873249651951637482264815937",
    d: -7318,
  },
  {
    p: "140958070000002050020000609004020387010005426070604900480000590000003802052000000",
    s: "146958273937462158825317649564129387319785426278634915483276591791543862652891734",
    d: -7318,
  },
  {
    p: "140290006000010900208073001403080010000047632000060048800006200000000895079800003",
    s: "147295386356418927298673451463582719985147632712369548831956274624731895579824163",
    d: -7318,
  },
  {
    p: "007002986020796104000800070082500360015039002006000751004003008000167400001400000",
    s: "147352986528796134963814275482571369715639842396248751674923518859167423231485697",
    d: -7226,
  },
  {
    p: "148359200050000000020010500010420960800005020000103005081234609900571348435986710",
    s: "148359276357642891629817534513428967894765123276193485781234659962571348435986712",
    d: -7337,
  },
  {
    p: "108936527002000380030002094000000000920100000506390000050703008300500400487601903",
    s: "148936527792415386635872194813254769924167835576398241259743618361589472487621953",
    d: -7226,
  },
  {
    p: "140080000208000900036901000705896001601503200394127680413008000060200000000300068",
    s: "149682357278435916536971824725896431681543279394127685413768592867259143952314768",
    d: -7090,
  },
  {
    p: "000607004087300250490100870840530010020000503005008402200803045034750008000000307",
    s: "152687934687349251493125876846532719729461583315978462271893645934756128568214397",
    d: -7541,
  },
  {
    p: "150092048086504000004810300001009502005403890870050400008160204010940030007005080",
    s: "153792648286534917794816325341689572625473891879251463938167254512948736467325189",
    d: -7414,
  },
  {
    p: "054000030030600020620070040001384060302069000076105000805007610007006008060810475",
    s: "154298736738641529629573841591384267382769154476125983845937612217456398963812475",
    d: -7541,
  },
  {
    p: "154308020980007300070400180039801000000230000210060803590042610600080000820600040",
    s: "154398726986127354372456189439871562768235491215964873593742618641589237827613945",
    d: -7541,
  },
  {
    p: "154008690020410305000050080009000510812500000000070800206107400000300768007640201",
    s: "154738692628419375793256184379824516812563947465971823236187459541392768987645231",
    d: -7226,
  },
  {
    p: "004062890003840000086300000475203160800650030069174500031000000507400308000007001",
    s: "154762893923845716786391245475283169812659437369174582631528974597416328248937651",
    d: -7541,
  },
  {
    p: "104009020060000301700610085405000000930050100000790002546021070000000016019376000",
    s: "154839627268547391793612485425168739937254168681793542546921873372485916819376254",
    d: -7318,
  },
  {
    p: "004900020000620517706508039000760080600035741007409000402000003300800100870340290",
    s: "154973628938624517726518439543761982689235741217489356492157863365892174871346295",
    d: -7090,
  },
  {
    p: "156007020004009608970004503000006100090071200000000037039000400002500060000608090",
    s: "156387924324159678978264513287436159593871246461925837639712485842593761715648392",
    d: -7098,
  },
  {
    p: "100403002090160580038000140060300008070825019080006407003000820019008060000040000",
    s: "156483972492167583738592146961374258374825619285916437643759821519238764827641395",
    d: -7318,
  },
  {
    p: "150729300000060500000005270412073065906052400030014702690207054000000900780001020",
    s: "158729346247368519369145278412973865976852431835614792693287154521436987784591623",
    d: -7414,
  },
  {
    p: "009000840042100000000079001073001009900030010800097250005000360001926005000083090",
    s: "159362847742158936638479521573241689926835714814697253295714368381926475467583192",
    d: -7376,
  },
  {
    p: "160000089000624015450001706705000600610050030008069574000500063000200000200900158",
    s: "162735489897624315453891726745382691619457832328169574971548263586213947234976158",
    d: -7226,
  },
  {
    p: "100274508020013640070500030400700000207905000000400706050040380382050400009002105",
    s: "163274598925813647874596231416728953237965814598431726751649382382157469649382175",
    d: -7226,
  },
  {
    p: "100900283392000000070000000029540000800000106705600000080319600036085000000470390",
    s: "164957283392864571578123469629541837843792156715638942487319625936285714251476398",
    d: -7376,
  },
  {
    p: "105070000879060000023801070000008400008109702500000008700910040650320800904005621",
    s: "165472983879563214423891576217638459348159762596247138782916345651324897934785621",
    d: -7226,
  },
  {
    p: "160950704007084005090000003930040800056398010480071069000030006000700500600020901",
    s: "168953724327184695594267183931642857756398412482571369815439276249716538673825941",
    d: -7226,
  },
  {
    p: "160200000000670890074000000001000603982106470000047210600000702407000938030700060",
    s: "169258347523674891874391526741925683982136475356847219698413752417562938235789164",
    d: -7318,
  },
  {
    p: "109720040500300972200409005040800037010204560300107020420010000090040001800902400",
    s: "169725348584361972273489615942856137718234569356197824425618793697543281831972456",
    d: -7541,
  },
  {
    p: "100509608400708239008004150009072000704050086000006000005020370600007000000905860",
    s: "172539648456718239398264157569872413724153986813496725985621374641387592237945861",
    d: -7318,
  },
  {
    p: "000000506058320090020001000000487651000619000010005008041903200000502000095108730",
    s: "173894526458326197629751483932487651584619372716235948841973265367542819295168734",
    d: -7318,
  },
  {
    p: "170009800050100007036470005500010000301504000490320650940231086003800009000940023",
    s: "174659832259183467836472915582716394361594278497328651945231786723865149618947523",
    d: -7090,
  },
  {
    p: "074805000000410753005760000021600070006040500907000826750006480069080230002070090",
    s: "174835962698412753235769148521698374386247519947153826753926481469581237812374695",
    d: -7541,
  },
  {
    p: "070036002080740060053080940000400759000060030042000618700804123401020000020000470",
    s: "174936582289745361653281947368412759917568234542379618796854123431627895825193476",
    d: -7226,
  },
  {
    p: "070000008603085040000610009000593084500872916900160305410006003056030092020000067",
    s: "175349628693285741248617539761593284534872916982164375417926853856731492329458167",
    d: -7414,
  },
  {
    p: "005000042300010509000200060507062834240100006860307000000800700082030605630000008",
    s: "175698342326714589498253167517962834243185976869347251954826713782431695631579428",
    d: -7318,
  },
  {
    p: "006000032820601504090007086200514698000060450004083200002100040060300800301020705",
    s: "176458932823691574495237186237514698918762453654983217582176349769345821341829765",
    d: -7090,
  },
  {
    p: "100800390009300107300097564053008000000005073924006815007001006000603021000000430",
    s: "176854392549362187382197564753218649618945273924736815837421956495683721261579438",
    d: -7226,
  },
  {
    p: "070020403080000000049506000600097008030042160094001000060075034350060807000000090",
    s: "176928453583714926249536781621397548735842169894651372968175234352469817417283695",
    d: -7376,
  },
  {
    p: "009060400000050000000210609500673002603090050020580000006005917000140230801907006",
    s: "179368425462759183358214679514673892683492751927581364246835917795146238831927546",
    d: -7318,
  },
  {
    p: "102403000307209000400000380620791400008605010914300050800050020200004000509000843",
    s: "182463975357289164496517382625791438738645219914328657843956721271834596569172843",
    d: -7226,
  },
  {
    p: "002036000547201000000004020670500300004872160000463000006105000030698257895327416",
    s: "182936574547281693963754821678519342354872169219463785726145938431698257895327416",
    d: -7587,
  },
  {
    p: "000900030796000580032080169510000890040008000027090040950730000001204958064059070",
    s: "185926734796413582432587169513642897649378215827195643958731426371264958264859371",
    d: -7090,
  },
  {
    p: "193000806264091073000000109009060204406015908000900007840620700920508000000009080",
    s: "193752846264891573758436129589367214476215938312984657841623795927548361635179482",
    d: -7541,
  },
  {
    p: "090006070270540006040917205530800907002075000060100024309020000720300000001009000",
    s: "195236478273548196648917235534862917912475683867193524389624751726351849451789362",
    d: -7318,
  },
  {
    p: "100007002400195760050000080800040030000700010200618904307400598080070020010003040",
    s: "196387452428195763753264189871549236649732815235618974367421598584976321912853647",
    d: -7318,
  },
  {
    p: "100000302000960015000302000580000006000075030923600070002700408700540623309006050",
    s: "196457382234968715875312964587193246461275839923684571652731498718549623349826157",
    d: -7318,
  },
  {
    p: "107624500600000200580000000006039000900207056751800920065400009000950860010368040",
    s: "197624538643785291582193674426539187938217456751846923865472319374951862219368745",
    d: -7541,
  },
  {
    p: "100030450684059000000407000741900060000300000503000000079064501030721009806093207",
    s: "197638452684259713352417896741982365968375124523146978279864531435721689816593247",
    d: -7226,
  },
  {
    p: "010450000095000234000020506176005300952000040400000100500008470380012600760030021",
    s: "213456987695187234847923516176845392952361748438279165521698473384712659769534821",
    d: -7226,
  },
  {
    p: "203040009080790310090310800109200008328074090056009237007000900032000060840006700",
    s: "213648579684795312795312846179263458328574691456189237567421983932857164841936725",
    d: -7090,
  },
  {
    p: "210009700075100009600700030903020081000014090400600300000005200007001900109400067",
    s: "214839756375146829698752134963527481782314695451698372846975213537261948129483567",
    d: -7376,
  },
  {
    p: "014000000600130090398006000920000753460500009000000040030061402082097630740305018",
    s: "214958367675132894398746521921684753467513289853279146539861472182497635746325918",
    d: -7541,
  },
  {
    p: "010600073490070000008005410002068000009007030000319028000406091601703204020050360",
    s: "215684973493172856768935412372568149189247635546319728837426591651793284924851367",
    d: -7226,
  },
  {
    p: "200308905980001360374000802000630008803900600040080003460000000000890750500400100",
    s: "216378945985241367374569812751632498823954671649187523468715239132896754597423186",
    d: -7318,
  },
  {
    p: "017300008008004000040681000020000680081470923060000004872040100400910802109208340",
    s: "217395468698724531345681279724139685581476923963852714872543196436917852159268347",
    d: -7090,
  },
  {
    p: "217060000900000010000391807840526070050970480720000506080709000300004000401050730",
    s: "217865943938247615564391827849526371156973482723418596682739154375184269491652738",
    d: -7226,
  },
  {
    p: "000690503750103892003050710001300007305714008070009000000408100100905000809060005",
    s: "218697543756143892493852716981326457325714968674589231567438129132975684849261375",
    d: -7226,
  },
  {
    p: "019003407000207000600000029100300000050062000402050603960000005000500198003100764",
    s: "219683457845297316637415829196348572358762941472951683961874235724536198583129764",
    d: -7376,
  },
  {
    p: "200000070900003600600059080093602700010834900080705300060900210049020806800060097",
    s: "231486579958173624674259183593612748716834952482795361367948215149527836825361497",
    d: -7226,
  },
  {
    p: "230700008869041305070306100900052030500000400000030007004000253708023060002560080",
    s: "231795648869241375475386192947152836523678419186934527694817253758423961312569784",
    d: -7226,
  },
  {
    p: "205009714089002065070000809307001206820506103910300500000068907000053400000700002",
    s: "235689714489172365671435829357841296824596173916327548143268957762953481598714632",
    d: -7090,
  },
  {
    p: "236080001098060020075029046500070010600090030320140000901700203800034000000002064",
    s: "236487591498561327175329846589673412614295738327148659941756283862934175753812964",
    d: -7226,
  },
  {
    p: "230581794541370800780000100000005000000900650600830900000702341050490000020610070",
    s: "236581794541379826789246135392165487814927653675834912968752341157493268423618579",
    d: -7541,
  },
  {
    p: "206040791508000030040010000029108040105000089060090203000702050000001900780900160",
    s: "236845791518279436947316825329168547175423689864597213691782354452631978783954162",
    d: -7318,
  },
  {
    p: "207000065100006039046000000873260000062410003091083276000308042000970350000000900",
    s: "237894165158726439946135728873269514562417893491583276719358642684972351325641987",
    d: -7226,
  },
  {
    p: "007900480984000001501004300003182054002070610140300028009000000358090100406038090",
    s: "237916485984753261561824379673182954892475613145369728729541836358697142416238597",
    d: -7090,
  },
  {
    p: "009167084000295000506030000905608000000970000763401800100306920600009345304582617",
    s: "239167584478295163516834279945628731821973456763451892157346928682719345394582617",
    d: -7587,
  },
  {
    p: "001000000605401000037060040009850634073140009080293700010020406000610200760930000",
    s: "241389567695471382837562941129857634573146829486293715318725496954618273762934158",
    d: -7226,
  },
  {
    p: "040587060093100408800300005409000086605800001000004053060918000002030004010400007",
    s: "241587369593162478876349125439251786625873941187694253764918532952736814318425697",
    d: -7318,
  },
  {
    p: "240900375800040000090703048400500213000019050000634009680300000927000400005406800",
    s: "241968375873145962596723148469587213738219654152634789684372591927851436315496827",
    d: -7226,
  },
  {
    p: "240370050700040009009680024000007410000160082910020370070002860501030200092010040",
    s: "246379158785241639139685724623897415457163982918524376374952861561438297892716543",
    d: -7541,
  },
  {
    p: "040153980600040001309600040050001000900006008036090170104367025003002400502084003",
    s: "247153986685749231319628547758231694921476358436895172194367825873512469562984713",
    d: -7090,
  },
  {
    p: "247000000000090438003150060072001540615420900400705001050040310304002005120000000",
    s: "247386159561297438983154267872931546615428973439765821756849312394612785128573694",
    d: -7226,
  },
  {
    p: "040859000090700548065000279100080002934000001080060497008040900000090084429500706",
    s: "247859613391726548865431279176984352934275861582163497618347925753692184429518736",
    d: -7090,
  },
  {
    p: "208067903010890004900100000064030070130709640809416532000000000720000301000301095",
    s: "248567913613892754957143826564238179132759648879416532391625487725984361486371295",
    d: -7090,
  },
  {
    p: "208000000507008400009401000050670140026100800400090306000740000702506030630000500",
    s: "248957613517368492369421785853672149926134857471895326195743268782516934634289571",
    d: -7376,
  },
  {
    p: "040087003300940017170300000091403020527816004600029005010004650062000071700001040",
    s: "249187563356942817178365492891453726527816934634729185913274658462598371785631249",
    d: -7414,
  },
  {
    p: "209670813078003054501804060000000600084106020006930000100009000800001006405068300",
    s: "249675813678213954531894267912487635384156729756932148167349582893521476425768391",
    d: -7226,
  },
  {
    p: "040850306300000850500001490007006005005278003603009200002000169954602008001000004",
    s: "249857316316924857578361492427136985195278643683549271732485169954612738861793524",
    d: -7226,
  },
  {
    p: "200010600000450902040200500006000000000304070401907305600892740038145200000000058",
    s: "253719684167458932849236517376581429592364871481927365615892743738145296924673158",
    d: -7318,
  },
  {
    p: "054310097000000021700902054000004080608190470030008260000801002070005018082030006",
    s: "254316897869457321713982654597624183628193475431578269945861732376245918182739546",
    d: -7226,
  },
  {
    p: "006010090009402706000000000010500029832049071690200008920100003000798042008300960",
    s: "256817394389452716471936285714583629832649571695271438927164853563798142148325967",
    d: -7226,
  },
  {
    p: "000031907604080005000060480080952370500010800000874000740008601916020048800000030",
    s: "258431967634789215197265483481952376572613894369874152743598621916327548825146739",
    d: -7226,
  },
  {
    p: "008470003604023751300095000100064005470009006965000034730250000840000000520047018",
    s: "258471693694823751317695842182364975473519286965782134731258469849136527526947318",
    d: -7414,
  },
  {
    p: "200971063340006001060438527000040106410063000006100074000302010130000645890014700",
    s: "258971463347526981961438527783245196419763258526189374674352819132897645895614732",
    d: -7231,
  },
  {
    p: "264000090000009800097604020000900501000450030900030004040072013000800672023190400",
    s: "264385197351729846897614325432967581176458239985231764648572913519843672723196458",
    d: -7318,
  },
  {
    p: "267400150000090080109000000010006000008000507920800001402100000093580000850009640",
    s: "267438159534791286189625374715346928348912567926857431472163895693584712851279643",
    d: -7098,
  },
  {
    p: "000500000510070800308006257103060090000805603025010784001053409900001078002000060",
    s: "267538941519472836348196257183764592794825613625319784871653429956241378432987165",
    d: -7226,
  },
  {
    p: "008509407030007200090021035804600001006900000020000063010084796000000000740296100",
    s: "268539417135467289497821635874653921356912874921748563512384796689175342743296158",
    d: -7318,
  },
  {
    p: "008039504040650029001004376003080700020010000004000005076102930089067000002000007",
    s: "268739514347651829951824376613485792725916483894273165576142938489367251132598647",
    d: -7318,
  },
  {
    p: "068074050500080006174536800015760030083100005040000910000600184801000003006813002",
    s: "268974351539281746174536829915762438783149265642358917327695184851427693496813572",
    d: -7414,
  },
  {
    p: "009036058080005203400800010000370020004020805807004009061000930900000740000900001",
    s: "279136458186745293453892617695378124314629875827514369561487932938251746742963581",
    d: -7376,
  },
  {
    p: "209008040154063009000070520002500000700000000000014200023000600010835070090600405",
    s: "279158346154263789638479521342586197761392854985714263523947618416835972897621435",
    d: -7098,
  },
  {
    p: "080003950000250030000000100000684009190000005020900063017006302500040096009028571",
    s: "281463957974251638365879124753684219196732485428915763817596342532147896649328571",
    d: -7318,
  },
  {
    p: "001400900304050020065702034000500700000628409056010000048000217000070806100006500",
    s: "281463975374159628965782134892534761713628459456917382648395217539271846127846593",
    d: -7318,
  },
  {
    p: "081037594759081030364200817005870029007950183908160000800000050000000300000008971",
    s: "281637594759481236364295817415873629627954183938162745893716452172549368546328971",
    d: -7587,
  },
  {
    p: "081007500060000309000016008530001076070003900090005000607089400300004290410000003",
    s: "281937564765248319943516728532491876176823945894675132627389451358164297419752683",
    d: -7376,
  },
  {
    p: "280003001005190200009200507000960002007300005901025076194602703370000600508739120",
    s: "286573941735194268419286537853967412627341895941825376194652783372418659568739124",
    d: -7231,
  },
  {
    p: "286000013010000506300060800030704065000000000000510900001080407040256000009401032",
    s: "286945713914837526375162894138794265597628341462513978621389457743256189859471632",
    d: -7376,
  },
  {
    p: "080070130970100248041200760020009071100025380850006900000601450000500693060030800",
    s: "286974135975163248341258769623849571194725386857316924738691452412587693569432817",
    d: -7414,
  },
  {
    p: "087000059006040802541920607100290004000070200090003100010039000000700000620001003",
    s: "287316459936547812541928637178295364365174298492683175714839526853762941629451783",
    d: -7376,
  },
  {
    p: "007500496001209000960400020036040580020807064010000002058004739100000600003090000",
    s: "287531496341269857965478123736942581529817364814356972658124739192783645473695218",
    d: -7318,
  },
  {
    p: "000530416054000302000000000900070080020150000740908023073605040012000007006800500",
    s: "287539416154786392369241758931472685628153974745968123873615249512394867496827531",
    d: -7376,
  },
  {
    p: "000001000003006097061037500000709800830040001000020006740008610300060052000900003",
    s: "287591364453286197961437528624719835839645271175823946742358619398164752516972483",
    d: -7406,
  },
  {
    p: "000000007760290500530007200640100379080060002003000160005010003406073000009004800",
    s: "291435687768291534534687291642158379187369452953742168825916743416873925379524816",
    d: -7376,
  },
  {
    p: "200507001800000009407000000000031500300760010041259307000375900080910700073846002",
    s: "296587431835124679417693825728431596359768214641259387162375948584912763973846152",
    d: -7226,
  },
  {
    p: "007003004060000000100275090030827009008409630409360087006500700002036040315702900",
    s: "297683514563194872184275396631827459728459631459361287946518723872936145315742968",
    d: -7090,
  },
  {
    p: "207600003000037082360001000001000804403028007870009031600014370009063500030002100",
    s: "297685413514937682368241795921376854453128967876459231682514379149763528735892146",
    d: -7226,
  },
  {
    p: "098016070651087020007000010006503007000720980010000000000040750470635800005009003",
    s: "298316574651487329347952618826593147534721986719864235963148752472635891185279463",
    d: -7318,
  },
  {
    p: "304700209008000000200900017000579400420016090690000053001600920002000005700000800",
    s: "314765289978231546256948317183579462425316798697824153531687924842193675769452831",
    d: -7098,
  },
  {
    p: "310200008890500020267980100600172380008000015000895000971300602500009800000001500",
    s: "315267498894513726267984153659172384728436915143895267971358642532649871486721539",
    d: -7541,
  },
  {
    p: "309280040020690370687000009068070001901400000705910000092103087000029030000000920",
    s: "319287546524691378687534219268375491931468752745912863492153687856729134173846925",
    d: -7226,
  },
  {
    p: "310000000504138096706409000900003120073015040040080600200506380000020000400001562",
    s: "319762458524138796786459213958643127673215849142987635291576384865324971437891562",
    d: -7226,
  },
  {
    p: "301600000000700000609215080087921065203567148506483970764150830000004200100000000",
    s: "321648597845739621679215483487921365293567148516483972764152839958374216132896754",
    d: -7587,
  },
  {
    p: "321600700760400915000000000000090500090000284007286030000105302010037000030040001",
    s: "321659748768423915945718623182394567693571284457286139874165392219837456536942871",
    d: -7376,
  },
  {
    p: "000080000040031050005647102030000400578364090100009000009800043003500007006010800",
    s: "321985764647231958895647132932158476578364291164729385219876543483592617756413829",
    d: -7376,
  },
  {
    p: "000108097500030208000026453009602100810090020240801060090065001608009032000280000",
    s: "324158697567934218981726453739642185816593724245871369492365871678419532153287946",
    d: -7541,
  },
  {
    p: "300007000009006710600004359702010098530409007001000000168000200900030580050000971",
    s: "325197864489356712617824359742513698536489127891762435168975243974231586253648971",
    d: -7318,
  },
  {
    p: "300081060801290470600300000502809730970003082408007600003008200049602058200000010",
    s: "327481569851296473694375821512869734976543182438127695163958247749612358285734916",
    d: -7090,
  },
  {
    p: "020009540004012786008007230030801950100004023009700164000976000060000005003100608",
    s: "327689541954312786618457239432861957176594823589723164845976312761238495293145678",
    d: -7541,
  },
  {
    p: "029000510007000000510000007900300700041279050783051296800102600134080070296730000",
    s: "329647518467815329518923467952368741641279853783451296875192634134586972296734185",
    d: -7414,
  },
  {
    p: "342600500000050200005032004003710049064580172100024000506100030007098600000005020",
    s: "342679581789451263615832794253716849964583172178924356526147938437298615891365427",
    d: -7226,
  },
  {
    p: "040080000000000000200510000700402000480136795651800240003000076008071500574068019",
    s: "346789152815624937297513468739452681482136795651897243123945876968371524574268319",
    d: -7226,
  },
  {
    p: "300010800018049720000807000069401032003060174400500008002000305035094680084000201",
    s: "347612859518349726926857413869471532253968174471523968792186345135294687684735291",
    d: -7090,
  },
  {
    p: "340900007072008000560017004450790106607183450000500002205004900800000001700200540",
    s: "348925617172468395569317824453792186627183459981546732215874963834659271796231548",
    d: -7541,
  },
  {
    p: "049705000687300100500080340000603800000090706060008002005000073030007421206430580",
    s: "349715268687342195521986347192673854853294716764158932415829673938567421276431589",
    d: -7226,
  },
  {
    p: "309010650000000028002000309000060400000025863605743001000376510000004786004580932",
    s: "349812657576439128812657349231968475497125863685743291928376514153294786764581932",
    d: -7090,
  },
  {
    p: "000408002040390050000610000623001079000904506004000008007500263435200010900000805",
    s: "351478692846392751279615384623851479718924536594763128187549263435286917962137845",
    d: -7318,
  },
  {
    p: "300600780060700920001200563520800000000420050080905030090000800800560247206000090",
    s: "352691784468753921971284563524836179139427658687915432795342816813569247246178395",
    d: -7318,
  },
  {
    p: "000086000907040000810050906000090000040028160029673040230800405000430090001065300",
    s: "352986714967241853814357926685194237743528169129673548236819475578432691491765382",
    d: -7318,
  },
  {
    p: "050090178000380000070040609400006900027019380600070002006100000095700060030005200",
    s: "354692178961387524872541639483256917527419386619873452246138795195724863738965241",
    d: -7376,
  },
  {
    p: "004701802018402070900083000039040000000238045402109730000000350840006010203010000",
    s: "354761892618492573927583461539647128761238945482159736196824357845376219273915684",
    d: -7226,
  },
  {
    p: "358700600040630805690582400080047060200006573000350240006000024000003700000100006",
    s: "358714692742639815691582437583247961214896573967351248836975124125463789479128356",
    d: -7226,
  },
  {
    p: "302910700108000030009240008281065007057020100090081050700004001800090024914000870",
    s: "362918745148576239579243618281465397457329186693781452725834961836197524914652873",
    d: -7090,
  },
  {
    p: "000070215001063080007200046400786009580130704710042000000650001600000000075300608",
    s: "364978215251463987897215346432786159586139724719542863928657431643891572175324698",
    d: -7226,
  },
  {
    p: "300000004174050320800340065600030000050102000423090006908720001500600080016085900",
    s: "365278194174956328892341765681534279759162843423897516948723651537619482216485937",
    d: -7226,
  },
  {
    p: "008409015042010009500630400000250003620800000950070006005760000280000570470000302",
    s: "368429715742518639591637428817256943623894157954371286135762894286943571479185362",
    d: -7318,
  },
  {
    p: "360040007150062438420003905003800002590007000000009510930100004000380000806094301",
    s: "369548127157962438428713965643851792591627843782439516935176284214385679876294351",
    d: -7541,
  },
  {
    p: "300009085805200000040030070412000050000970008980102300508400712000001800020000549",
    s: "371649285865217493249835671412368957653974128987152364538496712794521836126783549",
    d: -7318,
  },
  {
    p: "301800000850610370090003580008179400000000060039206800005908030000020000042531000",
    s: "371895642854612379296743581568179423127384965439256817715968234983427156642531798",
    d: -7318,
  },
  {
    p: "302600000081050024000020070000064005000002738908007402000000050054290681000000900",
    s: "372648519681759324549321876237864195465912738918537462193486257754293681826175943",
    d: -7098,
  },
  {
    p: "070001000005000620046200703520000907010050002039028000090170560400000018000680009",
    s: "372861495985743621146295783528316947614957832739428156893172564467539218251684379",
    d: -7376,
  },
  {
    p: "370000910504001000810567430000000000152700096040658300700036009200809000000005060",
    s: "376284915524391687819567432638912574152743896947658321781436259265879143493125768",
    d: -7318,
  },
  {
    p: "000000000009000310005360798903200400257600083104570902000905000098137040531000079",
    s: "376891524829754316415362798963218457257649183184573962742985631698137245531426879",
    d: -7090,
  },
  {
    p: "080691007090000008500400069002100895000870002809305710010008070406207000008016053",
    s: "384691527691752348527483169732164895145879632869325714913548276456237981278916453",
    d: -7541,
  },
  {
    p: "005701060000600508276009003009008002540127396701003005060005000402010900003200650",
    s: "385741269914632578276589143639458712548127396721963485167395824452816937893274651",
    d: -7541,
  },
  {
    p: "306007005004628709700050008000090107000080004675200900200039000003800400849500001",
    s: "386947215154628739792153648428395167931786524675214983217439856563871492849562371",
    d: -7318,
  },
  {
    p: "007006000204009007000000824008004502052700480470500906006030000045108093800420000",
    s: "387246159214859367569371824938614572652793481471582936126935748745168293893427615",
    d: -7318,
  },
  {
    p: "389506420006009000001200060840090216900800300710002890000401089500960140100005602",
    s: "389576421256149738471238965845793216962814357713652894637421589528967143194385672",
    d: -7414,
  },
  {
    p: "380640200605009374040030890006402730100090600000068050400000182090006500501280000",
    s: "389647215615829374742531896856412739174395628923768451467953182298176543531284967",
    d: -7541,
  },
  {
    p: "300647020807300690006800731080030179000010280710280400004000000003070960108903507",
    s: "391647825827351694546892731682435179435719286719286453974568312253174968168923547",
    d: -7414,
  },
  {
    p: "302060050000200000070090020000701063684500017730800040067400080425008076010670004",
    s: "392167458146285739578394621259741863684539217731826945967453182425918376813672594",
    d: -7226,
  },
  {
    p: "403000008000128306260943571036080700000007000007012003059030102002050839301000007",
    s: "413675298975128346268943571136589724824367915597412683759834162642751839381296457",
    d: -7090,
  },
  {
    p: "005026008087490012002010350000104709001580240040000105800201000030060007256000001",
    s: "415326978387495612692817354528134769761589243943672185879251436134968527256743891",
    d: -7226,
  },
  {
    p: "015903002680000300000102000900700060004000037076309185109005008000000020708020000",
    s: "415963872682574319397182456931758264854216937276349185129635748543897621768421593",
    d: -7098,
  },
  {
    p: "400000900062100000030040016280600003706823005003001200074908020658410370109000604",
    s: "417586932862139457935247816281654793796823145543791268374968521658412379129375684",
    d: -7090,
  },
  {
    p: "000967200600452000270010000000785903500200017000601000941006070080074650756008140",
    s: "418967235639452781275813496124785963563249817897631524941526378382174659756398142",
    d: -7090,
  },
  {
    p: "020100950015030000000425000072603840041000200080002030134007500058391764769584321",
    s: "423176958615839472897425613972613845341758296586942137134267589258391764769584321",
    d: -7337,
  },
  {
    p: "423800006900056104000000200802007340374000062500003708708192050600740801000000000",
    s: "423819576987256134165374289812967345374581962596423718748192653639745821251638497",
    d: -7226,
  },
  {
    p: "420600000007400208000001460060005000070219000090708040708006920006000305230050001",
    s: "425687193617493258983521467862345719574219836391768542758136924146972385239854671",
    d: -7376,
  },
  {
    p: "406150083703200000508003200630700500157009024982500307049680702000900030071300009",
    s: "426157983793268145518493276634712598157839624982546317349681752265974831871325469",
    d: -7231,
  },
  {
    p: "026509700030700620000001035015000090093180206060090150379600000008072060602803070",
    s: "426539781531748629987261435815426397793185246264397158379654812148972563652813974",
    d: -7090,
  },
  {
    p: "406001079790000100038507060813765004500000610000012300300056000264070030951300700",
    s: "426831579795624183138597462813765294542983617679412358387256941264179835951348726",
    d: -7414,
  },
  {
    p: "408500007090100004701080000600304109010900473003000260172803906060200080850690000",
    s: "428539617596172834731486592687324159215968473943715268172853946369241785854697321",
    d: -7541,
  },
  {
    p: "400070090000000806615008040090861350300000107001735260107000000500002078004980000",
    s: "428673591973154826615298743792861354356429187841735269187546932569312478234987615",
    d: -7318,
  },
  {
    p: "009001800315000960000900214290560100001400002050002006580004000030800700042090308",
    s: "429671835315248967678953214294567183861439572753182496587314629936825741142796358",
    d: -7318,
  },
  {
    p: "001628579820497600607530008169000805080000030054080067900005080200060050010042796",
    s: "431628579825497613697531248169374825782156934354289167946715382278963451513842796",
    d: -7587,
  },
  {
    p: "030280001070300200090006004016804007500760010827000000000900040063475902000023070",
    s: "435287691671349258298156734316894527549762813827531469752918346163475982984623175",
    d: -7318,
  },
  {
    p: "005000006200069380000531070912650708300100902046000000100076000000295030008014000",
    s: "435782196271469385689531274912653748357148962846927513123876459764295831598314627",
    d: -7318,
  },
  {
    p: "000009070010002060700000800670500108050916040009070006300000654000647930900050001",
    s: "436189275815732469792465813673524198258916347149378526327891654581647932964253781",
    d: -7376,
  },
  {
    p: "036070500090000000002950341000000003050600400160402759005700804084325010920000000",
    s: "436271598591834276872956341248597163759613482163482759315769824684325917927148635",
    d: -7318,
  },
  {
    p: "437001002090000800008035710203900100809356000006010008500180020000009500960000000",
    s: "437891652195762834628435719243978165819356247756214398574183926382649571961527483",
    d: -7376,
  },
  {
    p: "000800500000470009900010007706150090300700241804039070008640030200085160000921700",
    s: "437892516581476329962513487726154893395768241814239675158647932279385164643921758",
    d: -7226,
  },
  {
    p: "000650720502409000000300004709003408000008371301705200020000947040097180007204000",
    s: "438651729512479863976382514769123458254968371381745296125836947643597182897214635",
    d: -7226,
  },
  {
    p: "430900000106000205700000000910000827803091600065080100580032400641508392020409008",
    s: "438925761196347285752816943914653827873291654265784139589132476641578392327469518",
    d: -7414,
  },
  {
    p: "000905061001006839900000000200080000000603008083000704014039675009700100572861940",
    s: "438975261751426839926318457245187396197643528683592714814239675369754182572861943",
    d: -7541,
  },
  {
    p: "039000070870006001000800300087105900000068000004920183000603709790001035523090810",
    s: "439512678875436291261879354387145962912368547654927183148653729796281435523794816",
    d: -7541,
  },
  {
    p: "000000000300750960000800541030070100070490385045103600103245790000960013029001050",
    s: "452619837318754962697832541936578124271496385845123679163245798584967213729381456",
    d: -7090,
  },
  {
    p: "000067098900302165000958004200835006800400020567291803040019002002080400380004010",
    s: "453167298978342165621958734214835976839476521567291843746519382192683457385724619",
    d: -7231,
  },
  {
    p: "003080960620300005000506340100402807032070004000968200017003006008617009060004100",
    s: "453781962621349785789526341196432857832175694574968213917853426248617539365294178",
    d: -7541,
  },
  {
    p: "000000006006000500930067104070000915240700080569380240604023000700000801010900060",
    s: "457812396126439578938567124873246915241795683569381247684123759792654831315978462",
    d: -7318,
  },
  {
    p: "050721060710900580000030001304200619000309200291400350007590030049000000000600107",
    s: "458721963713946582926835741374258619865319274291467358187592436649173825532684197",
    d: -7226,
  },
  {
    p: "000700120001000604060019000013902007204300906097060243000804360040023078036000400",
    s: "458736129971285634362419785613942857284357916597168243725894361149623578836571492",
    d: -7541,
  },
  {
    p: "061000002080032000007051000310079600050003290000560130026015003100046500905307810",
    s: "461798352589432761237651984318279645654183297792564138826915473173846529945327816",
    d: -7541,
  },
  {
    p: "460700000010050073508930100080003010100800050032561908000070000821005690007089031",
    s: "463718529219654873578932164985423716146897352732561948394176285821345697657289431",
    d: -7541,
  },
  {
    p: "403028500079006000100004096000207860200001739000305100906500010030040000000009020",
    s: "463928571579136284182754396314297865258461739697385142926573418831642957745819623",
    d: -7376,
  },
  {
    p: "400200095200068000100045002300000104006300007051090080010800009084002730002039510",
    s: "467213895295768341138945672329587164846321957751694283513876429984152736672439518",
    d: -7318,
  },
  {
    p: "407900300190403800200510094019800000052100003000000000730605240520700006000238071",
    s: "467982315195463827283517694319854762652179483874326159731695248528741936946238571",
    d: -7226,
  },
  {
    p: "468090750103000608000386000092870516040600009000010000200160905059023001010540300",
    s: "468291753123457698975386124392874516741635289586912437234168975659723841817549362",
    d: -7090,
  },
  {
    p: "000070100000400358590280040051023900040500080089060000000650071005000600004032000",
    s: "468375129127496358593281746751823964346519287289764513932658471815947632674132895",
    d: -7098,
  },
  {
    p: "000020609900614030200597104010060500047250308008031006009080000860000000703042060",
    s: "471823659985614732236597184312468597647259318598731246129386475864175923753942861",
    d: -7226,
  },
  {
    p: "402960001051072009030051000000000900906185372500000086000009507300000400094018203",
    s: "472963851851472639639851724187236945946185372523794186268349517315627498794518263",
    d: -7226,
  },
  {
    p: "000005080100000009900270413700004590010006070804000326040709260030002007207040900",
    s: "473195682128463759956278413762384591315926874894517326541739268639852147287641935",
    d: -7318,
  },
  {
    p: "400003098001000000820050000503900807182035409790014003010079050960000070057000982",
    s: "475163298631298745829457136543926817182735469796814523218379654964582371357641982",
    d: -7541,
  },
  {
    p: "070308902962570003030000050000703000010006508090104306750800200086200730240000085",
    s: "475368912962571843831492657628753491314926578597184326753819264186245739249637185",
    d: -7541,
  },
  {
    p: "006000830001608900000200510604825703090104000027000050100502079002700084089403005",
    s: "476951832251638947938247516614825793395174268827396451143582679562719384789463125",
    d: -7541,
  },
  {
    p: "000100030000096074080050010700003002036029050200040067000070000100060023007835046",
    s: "479182635512396874683457219745613982836729451291548367364271598158964723927835146",
    d: -7376,
  },
  {
    p: "000003500805000306361200000008002137213074090590106248000021069000069050000080700",
    s: "479613582825947316361258974648592137213874695597136248754321869182769453936485721",
    d: -7541,
  },
  {
    p: "070020310030781504000403072740509000000000407860004000120036905004102063056007020",
    s: "479625318632781594518493672743519286291368457865274139127836945984152763356947821",
    d: -7090,
  },
  {
    p: "481000072920800500070010000000000000097250803004600729846009100030146987709000000",
    s: "481395672923867514675412398268973451197254863354681729846729135532146987719538246",
    d: -7226,
  },
  {
    p: "481030000090006403637024900070000306300041020120000800210490708700000009943070005",
    s: "481739652592186473637524981874952316369841527125367894216495738758613249943278165",
    d: -7541,
  },
  {
    p: "403600502000530001005240900050001089090475023701900054010000395009000008040090207",
    s: "483619572962537841175248936254361789896475123731982654617824395329756418548193267",
    d: -7541,
  },
  {
    p: "480000020731000650962580003300008040547306091019070060150800930003159000090000010",
    s: "485637129731294658962581473326918745547326891819475362154862937673159284298743516",
    d: -7414,
  },
  {
    p: "086000500900020000071900000650090078093000254128574000510600000040185907060049015",
    s: "486713529935426781271958436654392178793861254128574693519637842342185967867249315",
    d: -7090,
  },
  {
    p: "000123095000400070020005340309257060002300000850906003600502904200800106548600207",
    s: "487123695135469872926785341319257468762348519854916723671532984293874156548691237",
    d: -7414,
  },
  {
    p: "080000930306000807529037000730020000000000403000783065003400008290008306050362704",
    s: "487156932316249857529837641735624189862915473941783265673491528294578316158362794",
    d: -7226,
  },
  {
    p: "007530006326490500000860200243189000560700001000006003010370640790000300000904070",
    s: "487532916326491587951867234243189765569743821178256493812375649794618352635924178",
    d: -7226,
  },
  {
    p: "480920100206380400030040020700053081500700004008000509049175600600004010100060040",
    s: "487926153256381497931547826794653281512798364368412579849175632675234918123869745",
    d: -7226,
  },
  {
    p: "493216070000048003068003000270050000080132706346879050010320094009000008030000000",
    s: "493216875152748963768593412271654389985132746346879251817325694529467138634981527",
    d: -7541,
  },
  {
    p: "003010260050098010010643590062104070804900100500062809000009000005406901380001000",
    s: "493517268657298413218643597962184375834975126571362849146859732725436981389721654",
    d: -7541,
  },
  {
    p: "090800100568001037012953080000000000304078091871000002000000548640005010180400060",
    s: "493867125568241937712953486956132874324578691871694352239716548647385219185429763",
    d: -7226,
  },
  {
    p: "490027003270900450030850070010003040009000107062070005780540360600000590954000700",
    s: "495127683278936451136854279517293846349685127862471935781549362623718594954362718",
    d: -7541,
  },
  {
    p: "096017083100006090072305106000100059059000812000009600068003420700860000010900008",
    s: "496217583135486297872395146647128359359674812281539674968753421724861935513942768",
    d: -7226,
  },
  {
    p: "090800105500400020203000409620070003941080050008020000009600200872003600360210097",
    s: "496832175587491326213765489625179843941386752738524961159647238872953614364218597",
    d: -7226,
  },
  {
    p: "097200308200480100831000040000540690042000000006800000000038750070954001004070930",
    s: "497215368265483179831796245318547692942361587756829413129638754673954821584172936",
    d: -7318,
  },
  {
    p: "090000000060208014000560800007900320800000070020080050002153640310079205954820130",
    s: "498731562563298714271564893647915328835642971129387456782153649316479285954826137",
    d: -7541,
  },
  {
    p: "510080000600014800204056700900030486006548200708609501007000052000890000060073008",
    s: "513782964679314825284956713952137486136548279748629531897461352321895647465273198",
    d: -7541,
  },
  {
    p: "500000070067004000820000300000082000040073806000946701679201540480007032230000617",
    s: "513869274967324185824715369796182453142573896358946721679231548481657932235498617",
    d: -7541,
  },
  {
    p: "000008293060000870800390064492031680006000530300009420040000050630004012051820040",
    s: "514768293963412875827395164492531687186247539375689421249176358638954712751823946",
    d: -7090,
  },
  {
    p: "000978200300050498200043715680300000003800600020007309100709056800005137700100040",
    s: "514978263376251498298643715687394521953812674421567389142739856869425137735186942",
    d: -7090,
  },
  {
    p: "516309000000501007008006051340010206705060139060908400800000000007003048004000613",
    s: "516379824423581967978246351349715286785462139162938475831654792697123548254897613",
    d: -7226,
  },
  {
    p: "016470009090600701702090000254060000100034050068057140040000530007516000900040018",
    s: "516472389493685721782391465254168973179234856368957142641829537837516294925743618",
    d: -7541,
  },
  {
    p: "007200034028000600000107280030609070075804162600700590700000801201360009800000320",
    s: "517286934428593617396147285132659478975834162684712593763925841241368759859471326",
    d: -7541,
  },
  {
    p: "000060000032019065900500007000600782003850600081002453040925106096078000100006008",
    s: "518267349732419865964583217459631782273854691681792453847925136396178524125346978",
    d: -7541,
  },
  {
    p: "500006900760900083000080106300000405005000010906050078197400802450879000003125704",
    s: "518346927764912583239587146321798465875634219946251378197463852452879631683125794",
    d: -7090,
  },
  {
    p: "510060030000785016706030080090013000875009000601020800007006040002100067060070003",
    s: "518462739923785416746931582294813675875649321631527894157396248382154967469278153",
    d: -7318,
  },
  {
    p: "500283070007000080830000502080520309053009020792008400078004000001095007305000061",
    s: "519283674427956183836741592684527319153469728792138456978614235261395847345872961",
    d: -7226,
  },
  {
    p: "510004068740108000800600010302000750070400000000760000150000802230017000004280175",
    s: "519374268746128593823659417362891754975432681481765329157946832238517946694283175",
    d: -7318,
  },
  {
    p: "019006408860120090000040516002034100050297003003080700080010000030050970090002000",
    s: "519376428864125397327849516672534189158297643943681752785913264236458971491762835",
    d: -7318,
  },
  {
    p: "501409078800120940000000010000300592250091764900205000300900020009702001010683009",
    s: "521469378836127945497538216178346592253891764964275183385914627649752831712683459",
    d: -7090,
  },
  {
    p: "021940800048005790096008540060800005270090000010674000030481009002000604409000310",
    s: "521947836348165792796328541963812475274593168815674923637481259152739684489256317",
    d: -7541,
  },
  {
    p: "023010070679350010000000935830500004000047300000008090005001000012080040400673051",
    s: "523819476679354812184762935837596124951247368246138597365421789712985643498673251",
    d: -7318,
  },
  {
    p: "500000701001504003080700000800100236630400005000365008058900360702600104463050800",
    s: "526893741971524683384716529845179236637482915219365478158947362792638154463251897",
    d: -7541,
  },
  {
    p: "020409600040058010710306084067240090090680740080900260000100000056094070800063020",
    s: "528419637643758912719326584167245398392681745485937261934172856256894173871563429",
    d: -7090,
  },
  {
    p: "508479000000280540710030820001050300095100004203000001002014900047508003300700400",
    s: "528479136936281547714635829471856392695123784283947651862314975147598263359762418",
    d: -7226,
  },
  {
    p: "509608701007050000140200008005026300082400950300007002000890170000060094050701000",
    s: "529638741867154239143279568415926387782413956396587412634892175271365894958741623",
    d: -7318,
  },
  {
    p: "009073010001000000804092070006008201380040750150006890005809000970005000000030500",
    s: "529673418761584923834192675496758231382941756157326894245819367973465182618237549",
    d: -7376,
  },
  {
    p: "000800300030001600080340070900703061100005803058600742090000407800000200073250189",
    s: "529867314734591628681342975942783561167425893358619742296138457815974236473256189",
    d: -7226,
  },
  {
    p: "001407090680500200900108035270000800150082047040700100015006020800004010060000300",
    s: "531427698684593271927168435279641853156382947348759162415836729893274516762915384",
    d: -7318,
  },
  {
    p: "531680007802900005600053281000000700120540000906008540300000009015390000700800053",
    s: "531682497842971365697453281453269718128547936976138542384715629215396874769824153",
    d: -7226,
  },
  {
    p: "030100000000378005008040021051000009600409000203587060069050070020063500815700000",
    s: "536192847142378695978645321451236789687419253293587164369851472724963518815724936",
    d: -7318,
  },
  {
    p: "007140000001078000802600071008010640050090702020300058000729084000000067000506120",
    s: "537142896461978235892653471978215643356894712124367958615729384289431567743586129",
    d: -7318,
  },
  {
    p: "537000080000750092092008500058320007073086200004900000700492000005801000020075810",
    s: "537249186816753492492168573158324967973586241264917358781492635645831729329675814",
    d: -7226,
  },
  {
    p: "030719402000530098004806105005170006090040500617090300002007003089000057000080009",
    s: "538719462126534798974826135845173926293648571617295384462957813389461257751382649",
    d: -7226,
  },
  {
    p: "040300000200006104063070900008001006900400500000005078309000080710630000600000053",
    s: "541392867297856134863174925458721396976483512132965478329547681715638249684219753",
    d: -7137,
  },
  {
    p: "000000900308902501070305060280167050130009007759000100605731028013020795027008010",
    s: "541876932368942571972315864284167359136459287759283146695731428813624795427598613",
    d: -7587,
  },
  {
    p: "042000000800743012071000004923014006005630000000087050607008040098476000100300670",
    s: "542861397869743512371925864923514786785639421416287953637158249298476135154392678",
    d: -7226,
  },
  {
    p: "500000060090030000006000400309145270285079140700600005402060000938050021071820500",
    s: "543218769197436852826597413369145278285379146714682935452961387938754621671823594",
    d: -7541,
  },
  {
    p: "000870090297403806000900700820740001714008000600002400006200508902087010381000070",
    s: "543876192297413856168925743825749361714638925639152487476291538952387614381564279",
    d: -7541,
  },
  {
    p: "000038106630100045001460000180040607253086010760050030400507300000610080000004009",
    s: "547238196632179845891465723189342657253786914764951238428597361975613482316824579",
    d: -7226,
  },
  {
    p: "000009381000003600063050700300900572050380400906740130600030045805000007400018063",
    s: "547629381298173654163854729384961572751382496926745138619237845835496217472518963",
    d: -7541,
  },
  {
    p: "047003620328071049009452307054006930206030054000200760095300000000000000032007810",
    s: "547893621328671549169452387754186932286739154913245768895314276671528493432967815",
    d: -7414,
  },
  {
    p: "048109300000037084300050210050360001203090005007580603402905000080003000700846900",
    s: "548129376921637584376458219854362791263791845197584623432975168689213457715846932",
    d: -7541,
  },
  {
    p: "008000600200340000030500040400063108870420003160900020085690714900004000604100000",
    s: "548279631291346875736518942452763198879421563163985427385692714917834256624157389",
    d: -7318,
  },
  {
    p: "549000001000000000370205849000690300905300780400078900050703100700401052108050470",
    s: "549837261286149537371265849817694325965312784432578916654723198793481652128956473",
    d: -7541,
  },
  {
    p: "500280000040056000008307060850030200400912853000060097705820009600005730980070500",
    s: "561289374347156982298347165859734216476912853123568497735821649612495738984673521",
    d: -7541,
  },
  {
    p: "561090070000000080800003190005710208080905000007208000406070000108329460020600030",
    s: "561892374943157682872463195395716248284935716617248953436571829158329467729684531",
    d: -7318,
  },
  {
    p: "000370004840009000037641800000520080203087046085064009000036000450790001070405200",
    s: "562378914841259763937641852694523187213987546785164329129836475458792631376415298",
    d: -7541,
  },
  {
    p: "060407080170000000300000760040300006000280430683754210709501000801002670406800001",
    s: "562497183174638592398125764247319856915286437683754219729561348831942675456873921",
    d: -7541,
  },
  {
    p: "060037409009050008000961000890002070054000800671090000047003980000780034000040620",
    s: "562837419719254368438961752893412576254376891671598243147623985926785134385149627",
    d: -7318,
  },
  {
    p: "064010908930400000800597300740901503090052004000040719306170092070600100010800000",
    s: "564213978937486251821597346748961523193752864652348719386175492279634185415829637",
    d: -7090,
  },
  {
    p: "509004710001790500030000000000020870800450061194080000907002680240800000305901027",
    s: "569234718421798536738516249653129874872453961194687352917342685246875193385961427",
    d: -7226,
  },
  {
    p: "569200000402930601000080009100053806004000315005100047000600004708000002046002573",
    s: "569241738482937651371586429127453896694728315835169247213675984758394162946812573",
    d: -7226,
  },
  {
    p: "571809062004050019893001075050008000207004590000200008000500980700406003000080641",
    s: "571849362624357819893621475356978124287134596149265738462513987718496253935782641",
    d: -7541,
  },
  {
    p: "000100000390760400200800790450007080000346572027900340005073268730008004800020000",
    s: "574139826398762415261854793453217689189346572627985341915473268732698154846521937",
    d: -7541,
  },
  {
    p: "074008060002006900603014005356200894020040000040003002060402739080005000239060408",
    s: "574928361812536947693714285356271894728649513941853672165482739487395126239167458",
    d: -7090,
  },
  {
    p: "070040009694380000030090084080059420003000058250800071061007830300008100040003006",
    s: "578241369694385712132796584786159423413672958259834671961427835325968147847513296",
    d: -7226,
  },
  {
    p: "070200800230047005010580020903005600000000070765100200800000050047050396306791480",
    s: "579216834238947165614583927923475618481629573765138249892364751147852396356791482",
    d: -7541,
  },
  {
    p: "570038400000490500060050029280064901910800603030010780000102390190003070000009000",
    s: "579238416821496537463751829287364951915827643634915782756182394198643275342579168",
    d: -7226,
  },
  {
    p: "004003907097540208000807000000150062060028003021406080206000800040015600000082074",
    s: "584263917697541238312897546873159462465728193921436785236974851748315629159682374",
    d: -7226,
  },
  {
    p: "504093000260500700730000540073100250195027080000000407800200905307000001912000800",
    s: "584793162261584793739612548473168259195427386628935417846271935357849621912356874",
    d: -7226,
  },
  {
    p: "080000090090502000003001408007090630000000001650020000900300080310040970002879013",
    s: "586437192194582367723961458247198635839654721651723849975316284318245976462879513",
    d: -7098,
  },
  {
    p: "500910070000040000301075800020300090008129063013567000000000405800251000030090602",
    s: "586912374279843156341675829627384591458129763913567248192736485864251937735498612",
    d: -7318,
  },
  {
    p: "000063470600040891004080003720614059415030000096270004940000000060000745807001000",
    s: "589163472632547891174982563728614359415839627396275184943756218261398745857421936",
    d: -7541,
  },
  {
    p: "000080036002010050400509180020870600000090070076005010210708000045063729037000000",
    s: "591487236782316954463529187324871695158694372976235418219748563845163729637952841",
    d: -7318,
  },
  {
    p: "590003600000600020026100957080000000400030072005070019008045230004310790000200480",
    s: "591723648847659123326184957782591364419836572635472819178945236264318795953267481",
    d: -7318,
  },
  {
    p: "000600084000043507040050210000000000986025071207800650309100040070500162051000908",
    s: "592617384168243597743958216435761829986325471217894653329186745874539162651472938",
    d: -7226,
  },
  {
    p: "000084731040090685306510090260000108938000006400806329704960013810000900609030500",
    s: "592684731147293685386517294265349178938721456471856329754962813813475962629138547",
    d: -7587,
  },
  {
    p: "090640270017000689008900000000804500000790030704053000000000050329001004600400100",
    s: "593648271417235689268917345936824517152796438784153926841369752329571864675482193",
    d: -7098,
  },
  {
    p: "004610030002890450018400709809001005000706890000580020900070500200005970050908312",
    s: "594617238762893451318452769879321645125746893643589127931274586286135974457968312",
    d: -7090,
  },
  {
    p: "590002801208000406300000290060327040000004560002005300009080023820170654001250000",
    s: "594632871278591436316748295165327948937814562482965317759486123823179654641253789",
    d: -7541,
  },
  {
    p: "090020000300859620004607150030000000900100006462700810740510062021060070000372001",
    s: "596421738317859624284637159138246597975183246462795813743518962821964375659372481",
    d: -7541,
  },
  {
    p: "097130000000004000040500702170008009023067180060401320000803070002005938000270650",
    s: "597132846286794513341586792175328469423967185968451327659813274712645938834279651",
    d: -7226,
  },
  {
    p: "007000008200974000103000600820750090450310002000080005000047903000000807030801400",
    s: "597163248268974531143528679821756394456319782379482165685247913914635827732891456",
    d: -7098,
  },
  {
    p: "007400016048609527261030890015000982032108405084000031100800769000076140000000008",
    s: "597482316348619527261537894615743982932168475784925631123854769859276143476391258",
    d: -7587,
  },
  {
    p: "602439000305670902090210060400090086003000097926050100800721030000004000200580000",
    s: "612439758345678912798215364471392586583146297926857143854721639137964825269583471",
    d: -7226,
  },
  {
    p: "002000094500000081080901000458000900207003008001204007005300009740109820093600040",
    s: "612835794579462381384971256458716932267593418931284567125348679746159823893627145",
    d: -7318,
  },
  {
    p: "005274300809103004734096051000560032000000060076021085080302000003000007200705000",
    s: "615274398829153674734896251498567132152438769376921485987342516543619827261785943",
    d: -7226,
  },
  {
    p: "010200850002865000800003006200000590009304287000920600071002968028106300936500000",
    s: "617249853342865719895713426283671594169354287754928631571432968428196375936587142",
    d: -7090,
  },
  {
    p: "600324750500100030380706410800401097050900000001072600130200000008010070060830020",
    s: "619324758574198236382756419823461597756983142941572683137249865298615374465837921",
    d: -7226,
  },
  {
    p: "619570040304019070000040001800000003000003459403190608900080230538006197000030004",
    s: "619578342324619875785342961896254713172863459453197628941785236538426197267931584",
    d: -7090,
  },
  {
    p: "619054020007003001280000400104000905800095142005000700000039006092806570060500010",
    s: "619754823547283691283961457124678935876395142935142768751439286392816574468527319",
    d: -7226,
  },
  {
    p: "620300495050000002043200018200713046130000007700062039400001080560030020302090000",
    s: "621378495857149362943256718295713846136984257784562139479621583568437921312895674",
    d: -7541,
  },
  {
    p: "601094070000607000580000000076000050249070306050206740700430900400050000932060485",
    s: "621594873394687521587123694176349258249875316853216749715438962468952137932761485",
    d: -7226,
  },
  {
    p: "620000000504000003937108002000609301010405928200301700005210006002030400860500207",
    s: "621743589584962173937158642748629351316475928259381764495217836172836495863594217",
    d: -7541,
  },
  {
    p: "024003000000640200830702609000070900006231057570060000059080106000010400310400700",
    s: "624193578795648231831752649183574962946231857572869314459387126267915483318426795",
    d: -7318,
  },
  {
    p: "625010870070050000000007000037896000500001367002570048080004035050082704201735080",
    s: "625419873973658421814327596437896152598241367162573948789164235356982714241735689",
    d: -7414,
  },
  {
    p: "025000090000030000000016725400007030003080170708260040500000400207008916800001050",
    s: "625874391179532864384916725452197638963485172718263549531629487247358916896741253",
    d: -7376,
  },
  {
    p: "620900073900030046307650190590000004130009080068040921453000069806000050200360000",
    s: "625914873981237546347658192592186734134729685768543921453871269816492357279365418",
    d: -7414,
  },
  {
    p: "020508003000060000040200007000800630103070050900002000000089570798025006005340910",
    s: "627518493839764125541293867472851639183976254956432781314689572798125346265347918",
    d: -7376,
  },
  {
    p: "627800009000790603934620000000002041000000905489000236143056000700409000002080004",
    s: "627813459851794623934625187375962841216348975489571236143256798768439512592187364",
    d: -7226,
  },
  {
    p: "001800720590120030872060400007400000100036500060018000008300607403005902006000010",
    s: "631894725594127836872563491287459163149236578365718249928341657413675982756982314",
    d: -7318,
  },
  {
    p: "600974085007500016800200070702850400080160500569740800000600140106405708408020050",
    s: "631974285247538916895216374712859463384162597569743821953687142126495738478321659",
    d: -7231,
  },
  {
    p: "000480091000007500590031006370820000980513074245760010003000000100002050020000008",
    s: "632485791814697532597231486371824965986513274245769813453178629168942357729356148",
    d: -7318,
  },
  {
    p: "005210980000003421010000000070102500040000009250946008500320104724600830080007600",
    s: "635214987897563421412879356976182543148735269253946718569328174724691835381457692",
    d: -7226,
  },
  {
    p: "605009000091500003087000050002930600160740900000006102900004508004305200000008394",
    s: "635489721491527863287163459542931687168742935379856142923674518814395276756218394",
    d: -7318,
  },
  {
    p: "637009058850670100020300009006793040003500000105000020060000000000001080708235604",
    s: "637129458859674132421358769286793541943512876175846923364987215592461387718235694",
    d: -7318,
  },
  {
    p: "030001298901300000254000010800206005016500002000900081309140050040605000060700800",
    s: "637451298981372564254869317893216475416587932572934681329148756748695123165723849",
    d: -7318,
  },
  {
    p: "030000908824100000005008004050406890009081562000000107098200350500000079002305000",
    s: "637542918824179635915638724751426893349781562286953147498267351563814279172395486",
    d: -7318,
  },
  {
    p: "037000029008000006100206070270058061000400000501000030000095610009020840356000002",
    s: "637584129428179356195236478274358961963412587581967234842795613719623845356841792",
    d: -7376,
  },
  {
    p: "039500702010200390007000400000002100026004850004076000561090008000708500803005000",
    s: "639541782415287396287639415798352164326914857154876923561493278942768531873125649",
    d: -7376,
  },
  {
    p: "000002809200006070007980060700109000010028050384607290403800000002093600800260510",
    s: "641572839298436175537981462725149386916328754384657291463815927152793648879264513",
    d: -7226,
  },
  {
    p: "001570003090260105003100000478000010130004006950730804000010002080306570000050008",
    s: "641579283897263145523148967478625319132984756956731824365817492284396571719452638",
    d: -7318,
  },
  {
    p: "000000008010029600009643000000000503000200469900750200100405000806002004025980106",
    s: "642571398317829645589643712268194573751238469934756281193465827876312954425987136",
    d: -7376,
  },
  {
    p: "640000751070000080009500620783000902004060810016200035000704000097030540460902000",
    s: "642893751175426389839517624783145962524369817916278435351784296297631548468952173",
    d: -7226,
  },
  {
    p: "000790000075010369029506480700002004300000076000600803004927038900861542208050791",
    s: "643798215875214369129536487796382154382145976451679823514927638937861542268453791",
    d: -7587,
  },
  {
    p: "647831500098002031001659007009216008310080926826003700750128000980060000100000000",
    s: "647831592598742631231659847479216358315487926826593714753128469982364175164975283",
    d: -7587,
  },
  {
    p: "008029070302640509910030200800092700020080940100000000080000005756910830000250697",
    s: "648529173372641589915837264863492751527183946194765328289376415756914832431258697",
    d: -7541,
  },
  {
    p: "052084100908500400040000003570200801094050030003047600285009310060412000007000060",
    s: "652384179938571426741926583576293841194658237823147695285769314369412758417835962",
    d: -7226,
  },
  {
    p: "600092003000400050980650010200380107000070005047009000018900070060003800400805090",
    s: "654192783721438659983657412295384167836271945147569238318926574569743821472815396",
    d: -7376,
  },
  {
    p: "054082000200071006000450280589603172406015800700208400970030000043007900800100000",
    s: "654982317298371546317456289589643172426715893731298465972834651143567928865129734",
    d: -7090,
  },
  {
    p: "600020107000000030093100608039700050140000896500094013010500009080947000004000580",
    s: "658329147721468935493175628839716254147253896562894713316582479285947361974631582",
    d: -7318,
  },
  {
    p: "671300000000100000035008961200010090000903628003002417580030170000506803340700059",
    s: "671394582928165734435278961264817395157943628893652417582439176719526843346781259",
    d: -7090,
  },
  {
    p: "600400020040520176200701000050306912100005083396000000500610000400000009900050830",
    s: "671498325849523176235761498758346912124975683396182754583619247412837569967254831",
    d: -7318,
  },
  {
    p: "672413908000070003509000000985601300400700000060980015000007000190048007740050000",
    s: "672413958814579623539862741985621374421735869367984215253197486196248537748356192",
    d: -7318,
  },
  {
    p: "673200000859601702000005006007009038006708000502016400004050063300000010000003890",
    s: "673284951859631742241975386417529638936748125582316479194857263368492517725163894",
    d: -7318,
  },
  {
    p: "670000040300000000001065000807300090460000030009478201100000023706080054000910700",
    s: "678132549325749618941865372817326495462591837539478261184657923796283154253914786",
    d: -7098,
  },
  {
    p: "000195002900002008430708901084503209709010080020980000207040006000327000800650107",
    s: "678195342915432678432768951184573269759216483326984715297841536561327894843659127",
    d: -7090,
  },
  {
    p: "078203090090560000540890206460000027050072900007000365205736000030020058000950602",
    s: "678243591192567843543891276469385127351672984827419365285736419936124758714958632",
    d: -7414,
  },
  {
    p: "600000040900060005500807020000000598000190007700458162407002900089014006000500804",
    s: "678925341942361785531847629164273598825196437793458162457682913389714256216539874",
    d: -7318,
  },
  {
    p: "670500034813000002400000009240003876107005903300400201004051020731040090508000000",
    s: "679528134813974562452316789245193876187265943396487251964751328731842695528639417",
    d: -7541,
  },
  {
    p: "600003400320000060041956370008200006006407200032100700080041020067590000154000690",
    s: "679823451325714869841956372718235946596487213432169785983641527267598134154372698",
    d: -7541,
  },
  {
    p: "680000437709010085200300196060900753900040000010060904007092060003006540090400000",
    s: "681259437739614285254387196468921753972543618315768924547892361823176549196435872",
    d: -7226,
  },
  {
    p: "080000720000000310000004096410006038806130470050490001005820047060947052004001000",
    s: "681359724947682315532714896419276538826135479753498261195823647368947152274561983",
    d: -7226,
  },
  {
    p: "002730549900006100001900000203160080040007002090820415000050894000010073020079051",
    s: "682731549975246138431985726253164987148597362796823415317652894569418273824379651",
    d: -7541,
  },
  {
    p: "080532971700106000150000082040760003000958700000240150020300000070019260400005007",
    s: "684532971792186435153497682549761823231958746867243159926374518375819264418625397",
    d: -7226,
  },
  {
    p: "080103079000050000020704685900602008246008097018500046800001700401080060060000014",
    s: "685123479794856321123794685957642138246318597318579246839461752471285963562937814",
    d: -7541,
  },
  {
    p: "605730000009000030000548970900000013000360094130000600096410702007093105800000009",
    s: "685739421749126538213548976964257813578361294132984657396415782427893165851672349",
    d: -7318,
  },
  {
    p: "000500024050000001714203900801042009000070002092350100100035290520401680900700410",
    s: "689517324253984761714263958871642539365179842492358176146835297527491683938726415",
    d: -7090,
  },
  {
    p: "091074002000600004430280160060040010050030406804006539007062003906003240003090600",
    s: "691374852728651394435289167362945718159837426874126539517462983986713245243598671",
    d: -7090,
  },
  {
    p: "690405072004006805000100064800600023000040697009700008052000009100294080906530041",
    s: "691485372734926815528173964847659123215348697369712458452861739173294586986537241",
    d: -7090,
  },
  {
    p: "001000080200003507573008409802057130109062004300800000000080051930106008708035000",
    s: "691574283284693517573218469842957136159362874367841925426789351935126748718435692",
    d: -7541,
  },
  {
    p: "090000000042180930085000016460007001178940203500030007210060084000402100054010600",
    s: "691753428742186935385294716463827591178945263529631847217569384836472159954318672",
    d: -7541,
  },
  {
    p: "001807020008095700507006001000200037000061000906503010002950076700030009300700850",
    s: "691847523238195764547326981154289637873461295926573418412958376785632149369714852",
    d: -7318,
  },
  {
    p: "092000410100900078080001290901406000030205000274008509060302780328010000010809000",
    s: "692587413145923678783641295951476832836295147274138569469352781328714956517869324",
    d: -7541,
  },
  {
    p: "600000701010079603273801000800750002007018000021040008180025300030004060400307200",
    s: "694532781518479623273861954846753192957218436321946578189625347732194865465387219",
    d: -7226,
  },
  {
    p: "000270004300009672017000080000090306004000008701400259053920060070006023420030807",
    s: "695278134348519672217364985582791346934652718761483259853927461179846523426135897",
    d: -7226,
  },
  {
    p: "690014032000207000200000189009702000728000900510009420904006050002000091061020000",
    s: "695814732183297546247653189439762815728541963516389427974136258352478691861925374",
    d: -7318,
  },
  {
    p: "090058010081070006300061008000896105000145030005027064700012000208700691040009007",
    s: "697458312581273946324961758432896175876145239915327864769512483258734691143689527",
    d: -7090,
  },
  {
    p: "710400060084069027269000050390050000005030006026917003030040000001700805050100640",
    s: "713425968584369127269871354398654271175238496426917583832546719641792835957183642",
    d: -7226,
  },
  {
    p: "010298506500406917006107200040019300800760400000000009605080000120905043070600005",
    s: "714298536582436917936157284247519368859763421361842759695384172128975643473621895",
    d: -7541,
  },
  {
    p: "700000280800207103532000074450018326081340050600920841168500000307694510000000000",
    s: "716439285894257163532861974459718326281346759673925841168573492327694518945182637",
    d: -7587,
  },
  {
    p: "700260900000300001600190857180902000200000008065481092500003109003000074401620385",
    s: "718265943954378261632194857187952436249736518365481792576843129823519674491627385",
    d: -7414,
  },
  {
    p: "000453902000170030630009000281307059496200173000004000062000700140000000075642090",
    s: "718453962529176834634829517281367459496285173357914286962531748143798625875642391",
    d: -7541,
  },
  {
    p: "719000005023806901508007040034069502105000090002015380300500000901028000200903000",
    s: "719234865423856971568197243834769512175382496692415387387541629951628734246973158",
    d: -7541,
  },
  {
    p: "009006000803000160000080000290608070406030018138045020067003482041060050902050000",
    s: "719526843823974165654381297295618374476239518138745926567193482341862759982457631",
    d: -7226,
  },
  {
    p: "001000050600009201900010070006930008070452000002008003007500012000600900210780300",
    s: "721346859654879231983215674146937528378452196592168743867593412435621987219784365",
    d: -7098,
  },
  {
    p: "701800590308050002000060831005000000190500000000790000043125700500300004000489365",
    s: "721843596368951472954267831875614923192538647436792158643125789589376214217489365",
    d: -7318,
  },
  {
    p: "023901006941005732685023010000200078290000001104008000007580600450006003800300000",
    s: "723941586941865732685723914536219478298457361174638295317582649459176823862394157",
    d: -7541,
  },
  {
    p: "006000004018000030309010506681003075497500312250040960000004090930650800074029653",
    s: "726935184518462739349718526681293475497586312253147968865374291932651847174829653",
    d: -7587,
  },
  {
    p: "720000650591036072360700980000090038009003000000207000002348090043070010900500320",
    s: "728419653591836472364725981276194538819653247435287169152348796643972815987561324",
    d: -7226,
  },
  {
    p: "000064100060100004040209080012800050630702041800900300180020470200008510504607008",
    s: "728564193965183724341279685412836957639752841857941362186325479273498516594617238",
    d: -7541,
  },
  {
    p: "700436850500009004000100009002607000347510960800000170085061093270090580000000010",
    s: "729436851518279634634158729192687345347512968856943172485761293271394586963825417",
    d: -7226,
  },
  {
    p: "009010800853009016000305709978061502000097000102000974001800200200000300607002100",
    s: "729614853853729416416385729978461532345297681162538974591843267284176395637952148",
    d: -7226,
  },
  {
    p: "701504286426083597050002403008010700007250008960000005000000620000925000090060050",
    s: "731594286426183597859672413548319762317256948962847135175438629684925371293761854",
    d: -7541,
  },
  {
    p: "032008906508090000900300000090027060200903157400006002025600009073000025009205081",
    s: "732158946568794213914362578391527864286943157457816392825671439173489625649235781",
    d: -7226,
  },
  {
    p: "702000600106820040800170035040308521210007863360000900000000002009010380070080050",
    s: "732549618156823749894176235947368521215497863368251974681735492529614387473982156",
    d: -7226,
  },
  {
    p: "030400002009007143000039080006104308003000700007000419085003200071008590092715034",
    s: "738461952569827143214539687956174328143982765827356419485693271371248596692715834",
    d: -7090,
  },
  {
    p: "700102080260700301001963000300090000010000060070050239690230700120070940007819620",
    s: "739142586264785391581963472342698157915327864876451239698234715123576948457819623",
    d: -7090,
  },
  {
    p: "030000801040000705825070040000034006090205078056798000078020003900000584013050207",
    s: "739542861641983725825671349287134956394265178156798432578429613962317584413856297",
    d: -7541,
  },
  {
    p: "000581030100009040000420078410003007009708000670004820530800060007000380864930012",
    s: "742581936186379245953426178418253697329768451675194823531842769297615384864937512",
    d: -7541,
  },
  {
    p: "000002090860005014090864070039400000070000100451907008326000001510000900000301602",
    s: "745132896863795214192864573639418725278653149451927368326579481514286937987341652",
    d: -7318,
  },
  {
    p: "706950000900003004503024096030140079005200860000005420000509608008000007010308000",
    s: "746951382921683754583724196832146579495237861167895423274519638358462917619378245",
    d: -7318,
  },
  {
    p: "700980500005021609000400080104002893900000100038000004510000000027050936809340000",
    s: "746983512385721649291465387154672893972834165638519724513296478427158936869347251",
    d: -7318,
  },
  {
    p: "700030012090782064020000703007010400080907005009500078010009030576320040004070001",
    s: "748635912193782564625194783357218496481967325269543178812459637576321849934876251",
    d: -7226,
  },
  {
    p: "000082000008760900102900070417320609005096007003500480520000040034610000000000310",
    s: "749182563358764921162953874417328659285496137693571482521839746834617295976245318",
    d: -7318,
  },
  {
    p: "049086502000402009100530740000860000387000010096001008070600400005300071804900260",
    s: "749186532653472189128539746412863957387295614596741328271658493965324871834917265",
    d: -7226,
  },
  {
    p: "009002000050816970080400050904700300005040000607008001470020036060000007301005000",
    s: "749532618253816974186497253924761385815243769637958421478129536562384197391675842",
    d: -7098,
  },
  {
    p: "009063201300001409200790635000902046021480357007035000100007004080040700070000093",
    s: "749563281356821479218794635835972146921486357467135928192357864583649712674218593",
    d: -7090,
  },
  {
    p: "740620010000000820520100600050087900000000700280400060935704000012896007076032001",
    s: "749628315163975824528143679651387942394261758287459163935714286412896537876532491",
    d: -7226,
  },
  {
    p: "701940638890500017000000090005000070010007300070860200630008025080009703000650004",
    s: "751942638892536417346781592265314879418297356973865241639478125584129763127653984",
    d: -7318,
  },
  {
    p: "700096803081503000600020000978200006020004500064930000095600201007000400800052007",
    s: "752496813481573629639821754978215346123764598564938172395647281217389465846152937",
    d: -7318,
  },
  {
    p: "750400806608300190002865400209000000380006900010003078070059200900030000430080000",
    s: "753491826648372195192865437269718354387546912514923678876159243925634781431287569",
    d: -7318,
  },
  {
    p: "753000090842310706901005030100030060000500080500801003039786000685102009000000620",
    s: "753628194842319756961475832198234567324567981576891243239786415685142379417953628",
    d: -7541,
  },
  {
    p: "704180300820006095960500100607000900000004000095071602046000070000942001000060000",
    s: "754189326821436795963527148687253914132694857495871632546318279378942561219765483",
    d: -7376,
  },
  {
    p: "750314600830006001010000407507208000400000059000950084300000070081000003002001800",
    s: "759314628834726591216895437597248316428163759163957284345689172681572943972431865",
    d: -7376,
  },
  {
    p: "050080100806100003104007560000070051018540097075600302042760010000000746690000000",
    s: "759386124826154973134927568963872451218543697475691382342765819581239746697418235",
    d: -7226,
  },
  {
    p: "050000030140020500080730090008090002000060089902083170000070004000300806605801000",
    s: "759614238143928567286735491318597642574162389962483175831276954427359816695841723",
    d: -7098,
  },
  {
    p: "050602310086531400000000200000300009037208000008010000800903005015700903392005080",
    s: "759642318286531497143879256421356879537298641968417532874923165615784923392165784",
    d: -7318,
  },
  {
    p: "000000000610050080038006200000070030380490602540030970204000003060000001070382409",
    s: "759823146612954387438716295921678534387495612546231978294167853863549721175382469",
    d: -7376,
  },
  {
    p: "701402800050901024900008000500840060308006009020007583000364008004205000605000042",
    s: "761432895853971624942658731519843267378526419426197583297364158134285976685719342",
    d: -7226,
  },
  {
    p: "001509380003800007020000906435000000000008690000002013002083504006000000098000030",
    s: "761549382953826147824317956435691278217438695689752413172983564346175829598264731",
    d: -7137,
  },
  {
    p: "700000109150709060430100025027891006086503201010000803003000018045007002001004000",
    s: "762435189158729364439168725327891546986543271514276893673952418845617932291384657",
    d: -7541,
  },
  {
    p: "062904003815032904430008070376090058100000600900063001007000300003006000500007026",
    s: "762954813815732964439618572376491258124875639958263741647129385283546197591387426",
    d: -7226,
  },
  {
    p: "060000805930708004010462700020030008040180060608274001071003480480000159000800000",
    s: "764319825932758614815462793127936548349185267658274931271593486483627159596841372",
    d: -7541,
  },
  {
    p: "704930008008607000039000400070000600400500032000023709800200300206308175013700204",
    s: "764931528528647913139852467372489651491576832685123749857214396246398175913765284",
    d: -7226,
  },
  {
    p: "080500306000319800000867004263948000090002003004000089040000005015003472009005068",
    s: "781524396456319827932867514263948751198752643574136289647281935815693472329475168",
    d: -7226,
  },
  {
    p: "702905063001000209400021758000000490100094087000807000620509800000638500000472916",
    s: "782945163531786249496321758278163495165294387349857621627519834914638572853472916",
    d: -7414,
  },
  {
    p: "785134000906720130100000540000203000000607380300000270679051000030876000018400700",
    s: "785134692946725138123968547897213456251647389364589271679351824432876915518492763",
    d: -7541,
  },
  {
    p: "700100500000850761514000080309572018007361400051008027090710030000000970470090000",
    s: "786129543932854761514637289349572618827361495651948327295716834163485972478293156",
    d: -7090,
  },
  {
    p: "091804300000970401000201807150040060020006003900000500010089004800400630240700100",
    s: "791854326682973451534261897157348962428596713963127548315689274879412635246735189",
    d: -7318,
  },
  {
    p: "002084315000002000103009642030870000800596400001200700200030000000965108000020903",
    s: "792684315645312897183759642436871259827596431951243786269138574374965128518427963",
    d: -7318,
  },
  {
    p: "003200000400906002008047000830000205002000001000425700087502914120004830040710526",
    s: "793251648451986372268347159834179265572863491916425783687532914125694837349718526",
    d: -7541,
  },
  {
    p: "093402800108000006504070020000600000210005700900000503089000200050026907400950010",
    s: "793462851128539476564178329835647192216395784947281563689714235351826947472953618",
    d: -7376,
  },
  {
    p: "704000601018075400006009207080001020100900500000000090807040002061093870029080040",
    s: "794832651218675439356419287985361724173924568642758193837546912461293875529187346",
    d: -7318,
  },
  {
    p: "005030280030000567060005009801000672600500100372816000010074000900053000427100050",
    s: "795631284138492567264785319851349672649527138372816495513974826986253741427168953",
    d: -7226,
  },
  {
    p: "090000156030000400012750000900285300023090000080000094050070610341500807860000009",
    s: "798342156536918472412756938974285361623491785185637294259874613341569827867123549",
    d: -7318,
  },
  {
    p: "800000590000500007705800040170080429608210000000703080201407900380026004064000702",
    s: "812374596436592817795861243173685429648219375529743681251437968387926154964158732",
    d: -7226,
  },
  {
    p: "013050079607200513000173480080900000036540801900080005000000950408019702309020004",
    s: "813456279647298513295173486584961327736542891921387645162734958458619732379825164",
    d: -7414,
  },
  {
    p: "003924006060000320500030908040003000700208040600007203000052009180049060090600480",
    s: "813924756967185324524736918249563871731298645658417293476852139182349567395671482",
    d: -7318,
  },
  {
    p: "000390260260801090004250000001020306008005710506009008407062001009483000002000000",
    s: "815394267263871594794256183941728356328645719576139428487562931159483672632917845",
    d: -7318,
  },
  {
    p: "800402000079083005002957004200031007761005032500200810000504300000016050000320070",
    s: "815462793479183625632957184298631547761845932543279816127594368384716259956328471",
    d: -7226,
  },
  {
    p: "006005907009081025250000001400860000090013704130000000004050090081340200500196078",
    s: "816425937349781625257639841475862319692513784138974562764258193981347256523196478",
    d: -7226,
  },
  {
    p: "010005002309000850052006317005001084008507029700908635000002071100000243000103908",
    s: "816735492379214856452896317295361784638547129741928635963482571187659243524173968",
    d: -7414,
  },
  {
    p: "809000000002080060400105083001006035040000090708530120900000042103802679624007300",
    s: "819623457532784961476195283291476835345218796768539124987361542153842679624957318",
    d: -7541,
  },
  {
    p: "019642000350019040602007009000093008200704000090201060400105090906478500520900070",
    s: "819642357357819246642357189164593728285764931793281465478125693936478512521936874",
    d: -7090,
  },
  {
    p: "801700005940058100675002000102000000004805009350020000206941050509273846437586290",
    s: "821734965943658172675192438192367584764815329358429617286941753519273846437586291",
    d: -7337,
  },
  {
    p: "800697104005040630000000008040200879290000001070010000739024500080530000050006093",
    s: "823697154915842637467351928541263879298475361376918245739124586684539712152786493",
    d: -7318,
  },
  {
    p: "800900050510000609060000300040105060100030002005602413600428700079060801000009006",
    s: "823946157514387629967251384342175968196834572785692413631428795279563841458719236",
    d: -7318,
  },
  {
    p: "806400310700210000049006000910005030408100007500003104290570603600391200300600091",
    s: "826457319753219468149836572912745836438162957567983124291578643674391285385624791",
    d: -7090,
  },
  {
    p: "007059006045016007910700500609000100000083769000690320061570083094030071700900000",
    s: "827359416345216897916748532639427158452183769178695324261574983594832671783961245",
    d: -7090,
  },
  {
    p: "027610090000075216060020807002300074400759000609042000010008000208030760045060100",
    s: "827614593934875216561923847152386974483759621679142358716598432298431765345267189",
    d: -7541,
  },
  {
    p: "000009027005000040046503081083006000090020050062005400000000009309060804728000160",
    s: "831649527975218346246573981583496712497321658162785493614857239359162874728934165",
    d: -7376,
  },
  {
    p: "800965007900000050052080910040000070600010590510000030706001243390200060100034000",
    s: "831965427967142358452387916243859671678413592519726834786591243394278165125634789",
    d: -7318,
  },
  {
    p: "800100090405206010670000002006000000020007659749001000003795804000802903087400000",
    s: "832174596495286317671539482356928741128347659749651238213795864564812973987463125",
    d: -7318,
  },
  {
    p: "030070610006020407054030090000069004090082070068107003000040000000090201045813060",
    s: "832974615916528437754631892527369184391482576468157923179246358683795241245813769",
    d: -7318,
  },
  {
    p: "030706105007040008020000007380100006000008231016034070203050000040090503008410060",
    s: "834726195197345628625981347382179456479568231516234879263857914741692583958413762",
    d: -7318,
  },
  {
    p: "000000000060507800907001000382056900470023008609078010200005093000602500508310076",
    s: "835249761164537829927861435382156947471923658659478312246785193713692584598314276",
    d: -7226,
  },
  {
    p: "835000926000023084007006030700608000004205300000910000401007095963002078000000003",
    s: "835741926196523784247896531719638452684275319352914867421387695963452178578169243",
    d: -7318,
  },
  {
    p: "830017529071030004005002000640000301900040860000000002089070200062390048010806003",
    s: "836417529271935684495682137648259371927143865153768492389574216562391748714826953",
    d: -7226,
  },
  {
    p: "006000217000006340000320800400082160018040000605109000063004081500908000080003025",
    s: "836495217251876349749321856497582163318647592625139478963254781572918634184763925",
    d: -7318,
  },
  {
    p: "000492156510860740400050020070000010001000070050010892000070004720506981193248567",
    s: "837492156512863749469157328978625413241389675356714892685971234724536981193248567",
    d: -7587,
  },
  {
    p: "000420051015009700600000093006031074021000009307900000053080002004000000790042000",
    s: "839427651415369728672815493986231574521674839347958216153786942264593187798142365",
    d: -7098,
  },
  {
    p: "000679002000230107203800000060780290739406000100003070020598041000340700504007020",
    s: "841679532956234187273815964465781293739426815182953476327598641618342759594167328",
    d: -7541,
  },
  {
    p: "802036009170040000000710042000400028700082300020650001509301407217004005000005216",
    s: "842536179176249853953718642631497528795182364428653791569321487217864935384975216",
    d: -7090,
  },
  {
    p: "040637900603090200590082000005701020200803009000209753306000400000016570001000608",
    s: "842637915613495287597182346935761824274853169168249753326578491489316572751924638",
    d: -7226,
  },
  {
    p: "000030009036000080900800300394520800060000904020040150009062538253904671007153492",
    s: "845236719136497285972815346394521867561378924728649153419762538253984671687153492",
    d: -7587,
  },
  {
    p: "840000000701093800002074106000750010004138060000026005000000304406280570200005001",
    s: "845612793761593842392874156623759418954138267187426935518967324436281579279345681",
    d: -7318,
  },
  {
    p: "800003000003162004200004930000020500609430020007895016030009001001347000792608000",
    s: "845973162973162854216584937184726593659431728327895416438259671561347289792618345",
    d: -7226,
  },
  {
    p: "040710000930000020510306804060500048001469300050078001000607280000104600005900000",
    s: "846712539937845126512396874269531748781469352453278961194657283378124695625983417",
    d: -7318,
  },
  {
    p: "847003910005000024100000308000080000728060053300500200400038591900450000003900040",
    s: "847623915635891724192745368564382179728169453319574286476238591981457632253916847",
    d: -7318,
  },
  {
    p: "809000720020970080000240600900000000007000100413025006090132800035006209000059063",
    s: "849563721526971384371248695968317542257694138413825976694132857735486219182759463",
    d: -7318,
  },
  {
    p: "801600340740500201200104080075801020000700050190402070034060005607310090002000000",
    s: "851629347749583261263174589475831926328796154196452873934268715687315492512947638",
    d: -7226,
  },
  {
    p: "000000409694008300070104000000301040730000105419050708025000000087060003900210580",
    s: "851736429694528371273194856568371942732849165419652738325987614187465293946213587",
    d: -7318,
  },
  {
    p: "000670300060004807300829005410908600780000900900467008630700090070200080200046050",
    s: "852671349169354827347829165415938672786512934923467518634785291571293486298146753",
    d: -7226,
  },
  {
    p: "853010007904007120010903000080394010090260708000075096000730009239000074008000000",
    s: "853612947964587123712943685687394512495261738321875496146738259239156874578429361",
    d: -7226,
  },
  {
    p: "856103070921570030070200056700000010308001007512030894000060000004058009000010005",
    s: "856143972921576438473289156749825613368491527512637894295364781134758269687912345",
    d: -7226,
  },
  {
    p: "807002190902615074004090200700000400065000300480061000300100040000070080000958013",
    s: "857432196932615874614897235729583461165749328483261957378126549591374682246958713",
    d: -7318,
  },
  {
    p: "809320007000800905007510002400003806500070031018060070005001700003794000000005000",
    s: "859326417231847965647519382472153896596478231318962574965281743123794658784635129",
    d: -7376,
  },
  {
    p: "001070040700400038003000067004037020908024070307080050009008200006213090100056083",
    s: "861375942795462138243891567614537829958624371327189654539748216486213795172956483",
    d: -7226,
  },
  {
    p: "862000957019075048700090063000907005957080020000000701003060009190000600570300802",
    s: "862413957319675248745298163631927485957184326284536791423861579198752634576349812",
    d: -7541,
  },
  {
    p: "000100000010894005000050100072605340906473001004020870030540218001200003508300004",
    s: "865132497217894635493756182172685349986473521354921876639547218741268953528319764",
    d: -7541,
  },
  {
    p: "805204000420030800001560740600002010042000389010400620089600405756000001004000060",
    s: "865274193427931856391568742678392514542716389913485627189623475756849231234157968",
    d: -7226,
  },
  {
    p: "800001047003249560045678010024015879080090000500786004010050082000000730000000100",
    s: "869531247173249568245678913624315879387492651591786324716953482958124736432867195",
    d: -7541,
  },
  {
    p: "070400520650008007923500800300900060165002430009035000006000080000063074000089002",
    s: "871496523654328197923517846382941765165872439749635218296754381518263974437189652",
    d: -7318,
  },
  {
    p: "070300000105020084493000670009100006230049010014000000000603001608200009301090207",
    s: "872364195165927384493815672789132456236549718514786923927653841648271539351498267",
    d: -7318,
  },
  {
    p: "003005264609802000010000900096000730180600095000050000960030000005080019030209546",
    s: "873195264659842173214367958596428731182673495347951682961534827425786319738219546",
    d: -7318,
  },
  {
    p: "000600000395400670100080500700004025040300060610508407457003986900700302203000014",
    s: "874635291395421678126987543739164825548372169612598437457213986981746352263859714",
    d: -7090,
  },
  {
    p: "000900063050000280060005970506041320703096018108030600230000846010360050600700100",
    s: "874912563951673284362485971596841327723596418148237695237159846419368752685724139",
    d: -7090,
  },
  {
    p: "076521030000300600000040257103080720580030900092050300008090000400807000037000806",
    s: "876521439245379618319648257163984725584732961792156384658493172421867593937215846",
    d: -7318,
  },
  {
    p: "006093410050710030013000000900387000008640090000250368000460021700900080600000950",
    s: "876593412259714836413826579962387145538641297147259368395468721721935684684172953",
    d: -7318,
  },
  {
    p: "076032000040010207300745800407600092065079000098000750003007605600000073704003008",
    s: "876932541549816237321745869437658192265179384198324756913487625682591473754263918",
    d: -7541,
  },
  {
    p: "000675002060000700574200000030428501020090830008006020250780090180042600047500018",
    s: "891675342362814759574239186739428561625197834418356927256781493183942675947563218",
    d: -7090,
  },
  {
    p: "890006713010903004460100000000035900378091006009670040080060107001004800037800402",
    s: "892546713715923684463187295146235978378491526259678341984362157621754839537819462",
    d: -7090,
  },
  {
    p: "093170000705030192241000007000309075030004000050006930400567000502000004370201050",
    s: "893172546765438192241695387628319475937854621154726938489567213512983764376241859",
    d: -7226,
  },
  {
    p: "090000751205790046067450289708000500031502600506073900482067090103005062050000000",
    s: "894236751215798346367451289748619523931542678526873914482367195173985462659124837",
    d: -7587,
  },
  {
    p: "005700013007018250300090480189470060050809700000031800064200178570100000200907040",
    s: "895724613647318259312695487189472365453869721726531894964253178578146932231987546",
    d: -7414,
  },
  {
    p: "096030407035000091000807356900058670000040008000706009074580963053600700009000200",
    s: "896135427735264891412897356941358672567942138328716549274581963153629784689473215",
    d: -7541,
  },
  {
    p: "090400010000708906030601000652009070903006280000200609060810390304900100109570004",
    s: "896425713541738926237691548652389471973146285418257639765814392384962157129573864",
    d: -7541,
  },
  {
    p: "000713045014500090700000168009050010000900800020186409902600080170030900008290700",
    s: "896713245214568397753429168489357612561942873327186459932671584175834926648295731",
    d: -7226,
  },
  {
    p: "010000300534980000870004000269040500045000297000000406001098605690203174007000800",
    s: "912675348534982761876314952269147583145836297783529416421798635698253174357461829",
    d: -7226,
  },
  {
    p: "900000005750000429063000000300512004840300000001468053000601080080920010100875000",
    s: "912784635758136429463259178376512894845397261291468753537641982684923517129875346",
    d: -7318,
  },
  {
    p: "903005200452000093008002005000050021005041060600300050004803070070294500380076102",
    s: "913465287452187693768932415847659321235741869691328754524813976176294538389576142",
    d: -7541,
  },
  {
    p: "010024005080000261060000400520793608608001302030002500000006040850409020347000950",
    s: "913624785485937261762185439524793618678541392139862574291356847856479123347218956",
    d: -7541,
  },
  {
    p: "900000000700500180038100006073040000200300507500210960020001790009000000000098430",
    s: "915862374762534189438179256673945821291386547584217963326451798849723615157698432",
    d: -7406,
  },
  {
    p: "916500000200900100007016090003009087000408631600001000420760010071005964000004273",
    s: "916532748238947156547816392153629487792458631684371529429763815371285964865194273",
    d: -7541,
  },
  {
    p: "010004607300010008000906301570001009129040500830090074603029700040600902000003816",
    s: "918234657362715498457986321574361289129847563836592174683129745741658932295473816",
    d: -7090,
  },
  {
    p: "010076235005090600060080070000800500046750100103620807400908000020030000580004300",
    s: "918476235375192684264385971792841563846753129153629847431968752629537418587214396",
    d: -7318,
  },
  {
    p: "018500700030000500506704031060200007100060000000071906400350029057029000302008475",
    s: "918532764734186592526794831869245317175963248243871956481357629657429183392618475",
    d: -7226,
  },
  {
    p: "010020704500809200000005069000060000701030000369000407004300071090000000802590306",
    s: "918623754546879213237415869425967138781234695369158427654382971193746582872591346",
    d: -7098,
  },
  {
    p: "000050007003200090400010036000103000009025008018000302197030624800961073500472980",
    s: "921356847683247195475819236254183769369725418718694352197538624842961573536472981",
    d: -7090,
  },
  {
    p: "023100007080020509654009130000390000019072400230000700560000024000007800090060000",
    s: "923145687781623549654789132476398251819572463235416798567831924342957816198264375",
    d: -7376,
  },
];
